export default __webpack_public_path__ + "static/media/publication-step-1.d8a1d557.svg";